/* BÄR Envíos — calculadora de costo de envío en la PDP.
   Un solo correo (Andreani), 2 modalidades por producto: Sucursal / Domicilio.
   Fuente de verdad: la tabla EDITABLE de abajo. Las tarifas del checkout
   (Configuración → Envío en el admin) deben cargarse con estos mismos valores
   para que lo que ve el cliente sea lo que paga. */

window.BarShippingConfig = {
  /* Zona por código postal: 1000–1999 = CABA + GBA. Todo lo demás = resto del país.
     LIMITACIÓN CONOCIDA: Argentina no tiene un rango de CP limpio para "interior de
     la provincia de Buenos Aires" (Mar del Plata 7600, Bahía Blanca 8000, etc.
     comparten prefijo con otras provincias) — esos casos caen en "resto del país"
     y ven el precio más alto en vez de un tramo intermedio. Es conservador: nunca
     cobra de menos. Si hace falta precisión ahí, se agrega una tabla por localidad. */
  gbaRange: [1000, 1999],

  /* Días hábiles estimados — fijos, no varían por zona ni producto (confirmado por el cliente) */
  eta: { sucursal: '3–6', domicilio: '3–7' },

  /* EDITABLE — precios en ARS por producto (handle) y zona.
     REEMPLAZAR cuando cambien los costos reales de despacho. */
  rates: {
    'paralelas-bajas-bar':               { gba: { sucursal: 7000,  domicilio: 9000  }, resto: { sucursal: 10000, domicilio: 13000 } },
    'paralelas-altas-bar':               { gba: { sucursal: 15000, domicilio: 17000 }, resto: { sucursal: 46000, domicilio: 48000 } },
    'grips-bar':                         { gba: { sucursal: 7000,  domicilio: 9000  }, resto: { sucursal: 8000,  domicilio: 10000 } },
    'barra-estatica-bar':                { gba: { sucursal: 15000, domicilio: 18000 }, resto: { sucursal: 39000, domicilio: 40000 } },
    'barra-de-estaticos-desmontable-bar': { gba: { sucursal: 15000, domicilio: 18000 }, resto: { sucursal: 39000, domicilio: 40000 } }
  },

  /* Futuro: monto en ARS a partir del cual el envío es gratis (null = desactivado) */
  freeShippingThreshold: null
};

(function () {
  'use strict';

  var config = window.BarShippingConfig;
  var STORAGE_KEY = 'bar-shipping-cp';

  function formatARS(n) {
    return '$' + n.toLocaleString('es-AR');
  }

  function parseCP(raw) {
    var digits = (raw || '').replace(/\D/g, '');
    return digits.length === 4 ? digits : null;
  }

  function zoneFor(cp) {
    var n = parseInt(cp, 10);
    return (n >= config.gbaRange[0] && n <= config.gbaRange[1]) ? 'gba' : 'resto';
  }

  /* Los textos llegan traducidos por data-attributes desde bar-shipping-calc.liquid
     (un .js no pasa por Liquid, asi que no puede usar el filtro t). */
  function readI18n(root) {
    var d = root.dataset;
    return {
      carrier: d.i18nCarrier || 'Envíos con Andreani',
      pickup: d.i18nPickup || 'Retiro en sucursal',
      home: d.i18nHome || 'Envío a domicilio',
      eta: d.i18nEta || 'Entrega estimada {days} días hábiles',
      errorCp: d.i18nErrorCp || 'Ingresá un código postal de 4 dígitos.',
      errorNone: d.i18nErrorNone || 'No encontramos envíos para ese código postal.'
    };
  }

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function quote(handle, cp, i18n) {
    var product = config.rates[handle];
    if (!product) return null;
    var zone = zoneFor(cp);
    var zoneRates = product[zone];
    if (!zoneRates) return null;

    var options = [
      { name: i18n.pickup, price: zoneRates.sucursal, days: config.eta.sucursal },
      { name: i18n.home, price: zoneRates.domicilio, days: config.eta.domicilio }
    ];
    options.sort(function (a, b) { return a.price - b.price; });
    return options;
  }

  function skeletonHTML() {
    return '<div class="bar-ship__skeleton" aria-hidden="true">' +
      '<div class="bar-ship__skel-row"><span class="bar-ship__skel bar-ship__skel--name"></span><span class="bar-ship__skel bar-ship__skel--price"></span></div>' +
      '<div class="bar-ship__skel-row"><span class="bar-ship__skel bar-ship__skel--name"></span><span class="bar-ship__skel bar-ship__skel--price"></span></div>' +
      '</div>';
  }

  function resultsHTML(options, i18n) {
    var html = '<p class="bar-ship__zone">' + escapeHTML(i18n.carrier) + '</p>';
    options.forEach(function (opt, i) {
      if (i > 0) html += '<div class="bar-ship__divider"></div>';
      html += '<div class="bar-ship__option">' +
        '<div class="bar-ship__option-head">' +
        '<span class="bar-ship__carrier">' + escapeHTML(opt.name) + '</span>' +
        '<span class="bar-ship__price">' + formatARS(opt.price) + '</span>' +
        '</div>' +
        '<p class="bar-ship__eta">' + escapeHTML(i18n.eta).replace('{days}', opt.days) + '</p>' +
        '</div>';
    });
    return html;
  }

  function init(root) {
    var input = root.querySelector('.bar-ship__input');
    var button = root.querySelector('.bar-ship__btn');
    var results = root.querySelector('.bar-ship__results');
    var handle = root.getAttribute('data-product-handle');
    var i18n = readI18n(root);
    var pending = null;

    function show(html) {
      results.hidden = false;
      results.innerHTML = html;
    }

    function calculate() {
      var cp = parseCP(input.value);
      if (!cp) {
        show('<p class="bar-ship__msg">' + escapeHTML(i18n.errorCp) + '</p>');
        return;
      }
      clearTimeout(pending);
      show(skeletonHTML());
      /* breve pausa para que la consulta se sienta deliberada, no un parpadeo */
      pending = setTimeout(function () {
        var options = quote(handle, cp, i18n);
        if (!options || !options.length) {
          show('<p class="bar-ship__msg">' + escapeHTML(i18n.errorNone) + '</p>');
          return;
        }
        try { localStorage.setItem(STORAGE_KEY, cp); } catch (e) { /* modo privado */ }
        show(resultsHTML(options, i18n));
      }, 420);
    }

    button.addEventListener('click', calculate);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); calculate(); }
    });

    /* CP recordado de una visita anterior: precargar y calcular solo */
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved && parseCP(saved)) {
        input.value = saved;
        calculate();
      }
    } catch (e) { /* modo privado */ }
  }

  function boot() {
    document.querySelectorAll('[data-bar-shipping]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
